import { motion } from "framer-motion";
import CountUp from "react-countup";
// import { useInView } from "react-intersection-observer";
import "./ServicesSection.css";
import { FaHome, FaKey, FaBuilding, FaMapMarkerAlt } from "react-icons/fa";
import { GiCrane } from "react-icons/gi";
import { MdApartment } from "react-icons/md";

export default function ServicesSection() {


  return (
    <section className="services-section">
      
      {/* TOP SECTION */}
      <div className="services-container">
        <p className="services-subtitle">OUR SERVICES</p>
        <h2 className="services-title">Our Main Focus</h2>

        <div className="services-cards">

          {/* CARD 1 */}
          <motion.div 
            className="service-card"
            whileHover={{ y: -10 }}
          >
            <div className="service-icon">
              <FaHome />
            </div>
            <h3>Buy a Home</h3>
            <p>
              Discover premium properties tailored to your lifestyle 
              with modern design and luxury interiors.
            </p>
            <a href="/properties">Find A Home →</a>
          </motion.div>

          {/* CARD 2 */}
          <motion.div 
            className="service-card"
            whileHover={{ y: -10 }}
          >
            <div className="service-icon">
              <FaKey />
            </div>
            <h3>Rent a Home</h3>
            <p>
              Flexible rental options in prime locations with 
              complete security and transparency.
            </p>
            <a href="/">Find A Home →</a>
          </motion.div>

          {/* CARD 3 */}
          <motion.div 
            className="service-card"
            whileHover={{ y: -10 }}
          >
            <div className="service-icon">
              <FaBuilding />
            </div>
            <h3>Sell a Home</h3>
            <p>
              Get the best value for your property with 
              our expert marketing and trusted buyers.
            </p>
            <a href="/">Find A Home →</a>
          </motion.div>

        </div>
      </div>

      {/* STATS SECTION */}
   <div className="stats-section" >
        <div className="stats-container">

          <div className="stat-box">
            <GiCrane className="stat-icon" />
<h3>
  <CountUp
    end={260}
    duration={2}
    enableScrollSpy
    scrollSpyOnce
  />
  +
</h3>
            <p>Total Construction</p>
          </div>

          <div className="stat-box">
            <MdApartment className="stat-icon" />
<h3>
  <CountUp
    end={110}
    duration={2}
    enableScrollSpy
    scrollSpyOnce
  />
  +
</h3>
            <p>Apartio Rooms</p>
          </div>

          <div className="stat-box">
            <FaBuilding className="stat-icon" />
<h3>
  <CountUp
    end={190}
    duration={2}
    enableScrollSpy
    scrollSpyOnce
  />
  +
</h3>
            <p>Apartments Sold</p>
          </div>

          <div className="stat-box">
            <FaMapMarkerAlt className="stat-icon" />
<h3>
  <CountUp
    end={560}
    duration={2}
    enableScrollSpy
    scrollSpyOnce
  />
  +
</h3>
            <p>Total Area Sq</p>
          </div>

        </div>
      </div>

    </section>
  );
}